import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { usePixelRatio } from "../../hooks";
import URL from "../URL";
export const useBunnyOptimizedImageUri = (uri, { height, width } = {}) => {
    const [optimalUri, setOptimalUri] = useState(undefined);
    const [maxHeight, setMaxHeight] = useState(0);
    const [maxWidth, setMaxWidth] = useState(0);
    const [debouncedHeight] = useDebounce(height, 100);
    const [debouncedWidth] = useDebounce(width, 100);
    const pixelRatio = usePixelRatio({ step: 0.25, max: 2 });
    useEffect(() => {
        if (maxHeight || maxWidth) {
            setMaxHeight(0);
            setMaxWidth(0);
        }
    }, [uri]);
    useEffect(() => {
        if (!uri) {
            setOptimalUri(undefined);
            return;
        }
        const biggerWidth = debouncedWidth && debouncedWidth > maxWidth;
        const biggerHeight = debouncedHeight && debouncedHeight > maxHeight;
        if (!debouncedHeight && !debouncedWidth) {
            setOptimalUri(uri);
            return;
        }
        if (!(biggerHeight || biggerWidth)) {
            return;
        }
        if (biggerHeight)
            setMaxHeight(debouncedHeight);
        if (biggerWidth)
            setMaxWidth(debouncedWidth);
        try {
            const parsed = new URL(uri);
            if (debouncedHeight) {
                parsed.searchParams.append("height", Math.ceil(debouncedHeight * pixelRatio).toString());
            }
            else if (debouncedWidth) {
                parsed.searchParams.append("width", Math.ceil(debouncedWidth * pixelRatio).toString());
            }
            setOptimalUri(parsed.toString());
            return;
        }
        catch (err) {
            setOptimalUri(uri);
            return;
        }
    }, [uri, debouncedHeight, debouncedWidth, pixelRatio]);
    return optimalUri;
};
//# sourceMappingURL=useBunnyOptimizedImageUri.js.map